const SizeSelector = ({ sizes, selectedSize, setSelectedSize }) => {
    return (
      <div className="flex space-x-2">
        {sizes.map((size) => (
          <button
            key={size}
            onClick={() => setSelectedSize(size)}
            className={`w-10 h-10 flex items-center justify-center border ${
              selectedSize === size
                ? "bg-black text-white"
                : "border-[#BEBEBE] hover:border-black"
            }`}
          >
            {size}
          </button>
        ))}
      </div>
    );
  };
  
  export default SizeSelector;